
import Products from '../components/ProductsLayout'
import {useParams} from 'react-router-dom'
import React,{useRef,useState,useEffect} from 'react'
// import { products } from '../utils/products'
import Product from '../components/Product'
import classes from '../styles/Products.module.scss'
import Sidebar from '../components/Sidebar'
import { useSelector } from 'react-redux'
import { selectToggle} from '../redux/features/sidebarSlice'
import {items} from '../utils/navbarItems'
import {womenCategories,menCategories} from '../utils/filterItems'
import {FiChevronDown} from 'react-icons/fi'
import {BsChevronDown,BsChevronUp} from 'react-icons/bs'
import axios from 'axios'
import {searchForProduct,selectSearch} from '../redux/features/navbarSlice'
import { SpinnerDotted } from 'spinners-react';
import { GrClose } from "react-icons/gr";
import {Navigate, Outlet, useLocation, useNavigate} from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Layout from '../components/Layout'
import { selectProductsData, storeProducts, selectisGenderSwitched, switchGender } from '../redux/features/productSlice'


const Gender = () => {

    
    let {gender} = useParams()
    let {category} = useParams()

    const dispatch=useDispatch()

    //const [category,setCategory]=useState("men")
    const linksContainerRef = useRef([]);
    const linksRef = useRef([]);
    const [show, setShow] = useState(true)
    const [products, setproducts] = useState([])
    const [filteredProducts, setFilteredProducts] = useState([])
    const [active,setActive] = useState(false)
    const [sortOption, setSortOption] = useState("latest")
    let whatWeAreSearchingFor= useSelector(selectSearch)
    const [openFilters,setOpenfilters]=useState(false)
    const [desktop,setDesktop]=useState(true)
    const [categoryItems,setCategoryItems]=useState([])
    const [genderState,setGenderState]=useState("")
    const location = useLocation()
    let productsData= useSelector(selectProductsData)
    let isGenderSwitched = useSelector(selectisGenderSwitched)
    
    const navigate = useNavigate();

    // Read products of a specific category 
    const read = async ()=>{
        const {data}=await axios.get(`${process.env.REACT_APP_BACKEND_URL+"products/readbycategory/"+gender}`)
        setproducts(data)
    }

    
    const [idOfRemovedProduct, setIdOfRemovedProduct] = useState("");
    const [childCat, setChildCat] = useState("");

    // when the admin deletes a product, this remove the product from the list of products
    const handleDataFromChild = (id) => {
        setIdOfRemovedProduct(id);
        //console.log("this is the id of the removed product: "+id)
        setproducts(products.filter(product=> product._id != id))
    }

    useEffect(() => {
    // This runs only when the route changes
        //console.log("Route changed:", location.pathname);
        dispatch(storeProducts([]))
    }, [location.pathname]);


    useEffect(() => {
        // dispatch(switchGender(true))
        // //console.log("isGenderSwitched outside if: "+isGenderSwitched)
        // if (isGenderSwitched){
        //     //console.log("isGenderSwitched: "+isGenderSwitched)
        //     dispatch(storeProducts([]))
        //     dispatch(switchGender(false))
        //     //console.log("isGenderSwitched after set to false: "+isGenderSwitched)
        // }
        
        if (productsData.length > 0){
            setproducts(productsData)
        }else{
            read()
        }
        //console.log("products rendered")
        //console.log("this is gender: "+gender)
        // if the user is searching for products then display the products he is searching for
        if (whatWeAreSearchingFor.length>0 && products.length>0){
            setFilteredProducts(products.filter(product => product.name.toLowerCase().includes(whatWeAreSearchingFor.toLowerCase())))
            //console.log("filtered products: "+filteredProducts)
            //console.log("this is whatWeAreSearchingFor: "+whatWeAreSearchingFor)
        }

        if (gender==="men"){
            //setCategoryItems(menCategories)
            setGenderState("men")
        }else if (gender==="women"){
            //setCategoryItems(womenCategories)
            setGenderState("women")
        }

        //setChildCat(childCategory)
        ////console.log("child category is : "+childCategory)
        ////console.log("child category is : "+childCat)

        document.title = gender+" - Velocity Prime"
        setGenderState(gender)
        //console.log("category: "+genderState)
        
    }, [whatWeAreSearchingFor,gender,genderState,productsData])

    
    const readChildCategory = async (categoryLink,childCat)=>{
        navigate(categoryLink)
        //console.log("click function readChildCategory")
        const {data}=await axios.get(`${process.env.REACT_APP_BACKEND_URL+"products/childcategory/"+childCat}`)
        setproducts(data)
    }



    return (
       
        <div className={classes.container__grid} data-test="products">
            {
                category == null ? ( 
                    whatWeAreSearchingFor.length > 0
                    ? filteredProducts.map((product, index) => (
                        <Product
                            key={index}
                            product={product}
                            sendDataToParent={handleDataFromChild}
                        />
                        ))
                    : products.map((product, index) => (
                        <Product
                            key={index}
                            product={product}
                            sendDataToParent={handleDataFromChild}
                        />
                        ))
                ) : ( "" )
                
            }

            <Outlet />
        </div>
       
    )
}

export default Gender
